<template>
  <div class="user-info-card" v-if="hasUserInfo">
    <div class="user-avatar">
      <img class="avatar-image" :src="avatarSrc" :alt="$t('common.userAvatar')" @error="useDefaultAvatar" />
      <img
        class="gender-icon"
        :src="require(`../assets/sex/${user.gender}.png`)"
        v-if="user.gender === '1' || user.gender === '2'"
      />
    </div>
    <div class="user-details">
      <div class="user-name-row">
        <span class="user-name" v-if="hasValue(user.name)">{{ user.name }}</span>
        <span class="divider-vertical" v-if="hasValue(user.name) && hasValue(user.age)">|</span>
        <span class="user-age" v-if="hasValue(user.age)">{{ user.age }}{{ $t('user.age') }}</span>
      </div>
      <div class="user-metrics">
        <div class="metric" v-if="hasValue(user.user_height)">
          <span class="metric-label">{{ $t('user.height') }}</span>
          <span class="metric-value">{{ user.user_height }}{{ $t('user.heightUnit') }}</span>
        </div>
        <div class="metric" v-if="hasValue(user.user_weight)">
          <span class="metric-label">{{ $t('user.weight') }}</span>
          <span class="metric-value">{{ user.user_weight }}{{ $t('user.weightUnit') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const defaultAvatar = require('@/assets/default-avatar.svg');

export default {
  name: 'UserInfoCard',
  props: {
    user: {
      type: Object,
      default: null
    }
  },
  computed: {
    hasUserInfo() {
      if (!this.user) {
        return false;
      }
      return [
        this.user.name,
        this.user.age,
        this.user.user_height,
        this.user.user_weight,
        this.user.head_portrait
      ].some(this.hasValue);
    },
    avatarSrc() {
      return this.user?.head_portrait || defaultAvatar;
    }
  },
  methods: {
    hasValue(value) {
      if (value === undefined || value === null) {
        return false;
      }
      const text = String(value).trim();
      return text !== '' && text !== '0' && text !== '0.00';
    },
    useDefaultAvatar(event) {
      if (event.target.src !== defaultAvatar) {
        event.target.src = defaultAvatar;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.user-info-card {
  display: flex;
  align-items: center;
  border-radius: 15px;
  padding: 15px;
  margin: 20px 0;

  .user-avatar {
    position: relative;
    display: flex;
    width: 115px;
    height: 115px;
    border-radius: 50%;
    margin-right: 30px;
    flex-shrink: 0;
    background: #eef4ff;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 50%;
    }

    .gender-icon {
      position: absolute;
      bottom: 0;
      right: -10px;
      width: 36px;
      height: 36px;
      border-radius: 50%;
      padding: 2px;
      z-index: 10;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
    }
  }

  .user-details {
    flex: 1;
    min-width: 0;

    .user-name-row {
      display: flex;
      align-items: center;
      margin-bottom: 10px;

      .user-name {
        font-size: 32px;
        font-weight: 600;
        color: #00133d;
        margin-right: 15px;
      }

      .divider-vertical {
        color: #ced8e3;
        margin: 0 15px;
        font-weight: 300;
        font-size: 32px;
      }

      .user-age {
        font-size: 26px;
        color: #00133d;
      }
    }

    .user-metrics {
      display: flex;
      flex-wrap: wrap;

      .metric {
        display: flex;
        align-items: center;
        margin-right: 20px;

        .metric-label {
          font-size: 24px;
          color: #00133d;
          margin-right: 8px;
        }

        .metric-value {
          font-size: 24px;
          color: #00133d;
          font-weight: 500;
        }
      }
    }
  }
}
</style>
